// @flow strict
import * as React from 'react';

/**
 * @ignore
 */
export const FormatItalicActive = (): React.Element<*> => (
  <path d="M0.999 0.981v18h18v-18zM11.487 5.59l-2 9c-0.051 0.226-0.25 0.392-0.488 0.392-0.276 0-0.5-0.224-0.5-0.5 0-0.038 0.004-0.076 0.013-0.112l-0.001 0.003 2-9c0.051-0.226 0.25-0.392 0.488-0.392 0.276 0 0.5 0.224 0.5 0.5 0 0.038-0.004 0.076-0.013 0.112l0.001-0.003z"></path>
);
